<script setup lang="ts">
// types
import type { BlockBannerCompactProps } from '@ts-blocks/block-banner-compact/interfaces'
// hooks
import { useBlockBannerCompact } from '@hooks/blocks/block-banner-compact.hook'
// components
import { Button } from '@brighterly/lib-lumee-ui'
import { BrandShapeIcon } from '@UI/Brand/BrandShapeIcon'
import { AppIconStrapi } from '@UI/Icons/AppIconStrapi'

defineOptions({
  name: 'BlockBannerCompact',
})

const props = defineProps<{
  block: BlockBannerCompactProps
}>()

const {
  refCtaText,
  refCtaHref,
  refCtaTarget,
  handleClickCta,
} = useBlockBannerCompact({
  block: () => props.block,
})
</script>

<template>
  <article class="block-banner-compact">
    <div class="block-banner-compact__content">
      <BrandShapeIcon
        class="block-banner-compact__icon"
        shape="square"
        color="ultraviolet"
        size="lg"
      >
        <AppIconStrapi
          v-if="block.icon"
          :icon="block.icon"
        />
      </BrandShapeIcon>
      <div class="block-banner-compact__text">
        <h2 class="block-banner-compact__title btly-text-heading-m md:btly-text-heading-l lg:btly-text-heading-xl">
          {{ block.title }}
        </h2>
        <p
          v-if="block.description"
          class="block-banner-compact__description btly-text-body-l lg:btly-text-body-xl"
        >
          {{ block.description }}
        </p>
      </div>
    </div>

    <a
      class="block-banner-compact__cta"
      :href="refCtaHref"
      :target="refCtaTarget"
      :rel="refCtaTarget === '_blank' ? 'noopener noreferrer' : undefined"
      @click="handleClickCta"
    >
      <Button
        view="accent"
        size="md"
        trailing-icon="arrow-right"
        :text="refCtaText"
        tabindex="-1"
      />
    </a>
  </article>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockBannerCompact.scss" />
